import React from 'react';
import { Link } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
    return (  
        <>
            <div className='admin-grid-card'>
                <div className='admin-card'>
                    <img className='admin-test-image' src='https://konfidenceonline.com/assets/img/praktiz-aptitude.png' alt='aptitude test'/>
                    <h1 className='admin-test-title'>Aptitude Test</h1>
                    <p className='admin-test-info'> Results for Aptitude Test </p>
                    <Link to=''>
                        <button className='admin-test-button'> View Results </button>
                    </Link>    
                </div>

                <div className='admin-card'>
                    <img className='admin-test-image' src='https://image.freepik.com/free-vector/statistical-analysis-man-cartoon-character-with-magnifying-glass-analyzing-data-circular-diagram-with-colorful-segments-statistics-audit-research_335657-2698.jpg' alt='personality test'/>
                    <h1 className='admin-test-title'>Personality Test</h1>
                    <p className='admin-test-info'> Results for Personality Test </p>
                    <Link to=''>
                        <button className='admin-test-button'> View Results </button>
                    </Link> 
                </div>

                <div className='admin-card'>
                    <img className='admin-test-image' src='https://img.freepik.com/free-vector/person-covering-emotions-searching-identity_74855-5560.jpg' alt='eq test'/>
                    <h1 className='admin-test-title'>Website Registerations</h1>
                    <p className='admin-test-info'> View our Webinar Registerations  </p>
                    <Link to='/admin-webinar-responses'>
                        <button className='admin-test-button'> View Results </button>
                    </Link>    
                </div>
            </div>
        </>
    );
}
 
export default AdminDashboard;
